import React from "react";
import "../Navigation/css/NavBar.scss";

export default function SupportedDataTypes() {
    return (
        <div>
            Supported Data Types
        </div>
    )
}